export default __webpack_public_path__ + "static/rosenfeld-26ee5971298cf469d3e61216abc57bd2.jpg";